<div class="dialog-container">
    <div class="se-dialog-header">
        <h3 class="se-dialog-title" translate>ObscuredConfidentialityTitle</h3>
    </div>

    <mat-dialog-content *ngIf="obscuredData; else noData">
        <!-- 1: Lombardia/Piemonte -->
        <ng-container *ngIf="type === 1">
            <mat-checkbox disabled [(ngModel)]="obscuredData.authorizationExternal">{{
                "chkAuthorizationExternal" | translate
            }}</mat-checkbox>
            <mat-checkbox [disabled]="isDisabled" [(ngModel)]="obscuredData.obscuredReferringPhysician">{{
                "chkObscuredReferringPhysician" | translate
            }}</mat-checkbox>

            <div class="control-grid">
                <mat-checkbox [(ngModel)]="obscuredData.obscuredDrug" [disabled]="isDisabled">{{
                    "chkObscuredDrug" | translate
                }}</mat-checkbox>
                <mat-checkbox [(ngModel)]="obscuredData.obscuredHIV" [disabled]="isDisabled">{{
                    "chkObscuredHIV" | translate
                }}</mat-checkbox>
                <mat-checkbox [(ngModel)]="obscuredData.obscuredViolence" [disabled]="isDisabled">{{
                    "chkObscuredViolence" | translate
                }}</mat-checkbox>
                <mat-checkbox [(ngModel)]="obscuredData.obscuredInterruption" [disabled]="isDisabled">{{
                    "chkObscuredInterruption" | translate
                }}</mat-checkbox>
                <mat-checkbox [(ngModel)]="obscuredData.obscuredAnonymityBirth" [disabled]="isDisabled">{{
                    "chkObscuredAnonymityBirth" | translate
                }}</mat-checkbox>
                <mat-checkbox [(ngModel)]="obscuredData.obscuredFamilyCounseling" [disabled]="isDisabled">{{
                    "chkObscuredFamilyCounseling" | translate
                }}</mat-checkbox>
            </div>
        </ng-container>

        <!-- 2 Veneto -->
        <ng-container *ngIf="type === 2">
            <mat-radio-group [(ngModel)]="obscuredData.confidentialityCode" [disabled]="isDisabled">
                <mat-radio-button [value]="0">{{ "ObscuringConfidentialityCodeN" | translate }}</mat-radio-button>
                <mat-radio-button [value]="1">{{ "ObscuringConfidentialityCodeV" | translate }}</mat-radio-button>
            </mat-radio-group>

            <mat-checkbox class="full-width mt-1" [(ngModel)]="obscuredData.mediationNeeded" [disabled]="isDisabled">{{
                "ObscuringMediationRequired" | translate
            }}</mat-checkbox>
        </ng-container>

        <!-- 3 Visibilità personlizzate -->
        <ng-container *ngIf="type === 3">
            <mat-checkbox [(ngModel)]="obscuredData.authorizationExternal" disabled>{{
                "chkAuthorizationExternal" | translate
            }}</mat-checkbox>
        </ng-container>

        <!-- 4 FSE 2.0 -->
        <ng-container *ngIf="type === 4">
            <div class="full-width se-obscuredconfidentiality-title">
                <mat-label>{{ "Confidentiality" | translate }}</mat-label>
                <mat-icon class="se-info-icon" [seImageTooltip]="images.FSEHelpConfidentialityImage"
                    >help_outline</mat-icon
                >
            </div>
            <mat-radio-group
                class="vertical-radio-group"
                [(ngModel)]="obscuredData.confidentialityCode"
                [disabled]="isDisabled"
            >
                <mat-radio-button [value]="0"
                    ><div class="checkbox-info-label">
                        <span>{{ "chkConfidentialityNormalFSE20" | translate }}</span>
                        <mat-icon class="se-info-icon" [seImageTooltip]="images.FSEHelpConfidentialityNormalImage"
                            >help_outline</mat-icon
                        >
                    </div></mat-radio-button
                >
                <mat-radio-button [value]="1"
                    ><div class="checkbox-info-label">
                        <span>{{ "chkConfidentialityRestrictedFSE20" | translate }}</span>
                        <mat-icon class="se-info-icon" [seImageTooltip]="images.FSEHelpConfidentialityVeryRestrictedImage"
                            >help_outline</mat-icon
                        >
                    </div></mat-radio-button
                >
            </mat-radio-group>
            <div class="full-width se-obscuredconfidentiality-title">
                <mat-label>{{ "ObscuredTitle" | translate }}</mat-label>
                <mat-icon class="se-info-icon" [seImageTooltip]="images.FSEHelpObscuringImage"
                    >help_outline</mat-icon
                >
            </div>
            <div>
                <mat-checkbox [(ngModel)]="obscuredData.obscuredDocument" [disabled]="isDisabled">
                    <div class="checkbox-info-label">
                        <span>
                            {{ "DocumentBlackoutToOthers" | translate }}
                        </span>
                        <mat-icon class="se-info-icon" [seImageTooltip]="images.FSEHelpObscuringP99Image"
                            >help_outline</mat-icon
                        >
                    </div></mat-checkbox
                >
            </div>
            <div>
                <mat-checkbox [(ngModel)]="obscuredData.mediationNeeded" [disabled]="isDisabled">
                    <div class="checkbox-info-label">
                        <span>{{ "DocumentBlackoutToPatient" | translate }}</span>
                        <mat-icon class="se-info-icon" [seImageTooltip]="images.FSEHelpObscuringP98Image"
                            >help_outline</mat-icon
                        >
                    </div>
                </mat-checkbox>
            </div>
            <div>
                <mat-checkbox [(ngModel)]="obscuredData.obscuredParent" [disabled]="isDisabled">
                    <div class="checkbox-info-label">
                        <span>{{ "DocumentBlackoutToParent" | translate }}</span>
                        <mat-icon class="se-info-icon" [seImageTooltip]="images.FSEHelpObscuringP97Image"
                            >help_outline</mat-icon
                        >
                    </div>
                </mat-checkbox>
            </div>
        </ng-container>

        <ng-container *ngIf="hasSpecialLaws">
            <mat-checkbox
                *ngIf="customVisibility?.obscuredReferringPhysicianVisibility"
                [(ngModel)]="obscuredData.obscuredReferringPhysician"
                [disabled]="isDisabled"
                >{{ "chkObscuredReferringPhysician" | translate }}</mat-checkbox
            >

            <div class="control-grid">
                <mat-checkbox
                    *ngIf="customVisibility?.obscuredDrugVisibility"
                    [(ngModel)]="obscuredData.obscuredDrug"
                    [disabled]="isDisabled"
                    >{{ "chkObscuredDrug" | translate }}</mat-checkbox
                >
                <mat-checkbox
                    *ngIf="customVisibility?.obscuredHIVVisibility"
                    [(ngModel)]="obscuredData.obscuredHIV"
                    [disabled]="isDisabled"
                    >{{ "chkObscuredHIV" | translate }}</mat-checkbox
                >
                <mat-checkbox
                    *ngIf="customVisibility?.obscuredViolenceVisibility"
                    [(ngModel)]="obscuredData.obscuredViolence"
                    [disabled]="isDisabled"
                    >{{ "chkObscuredViolence" | translate }}</mat-checkbox
                >
                <mat-checkbox
                    *ngIf="customVisibility?.obscuredInterruptionVisibility"
                    [(ngModel)]="obscuredData.obscuredInterruption"
                    [disabled]="isDisabled"
                    >{{ "chkObscuredInterruption" | translate }}</mat-checkbox
                >
                <mat-checkbox
                    *ngIf="customVisibility?.obscuredAnonymityBirthVisibility"
                    [(ngModel)]="obscuredData.obscuredAnonymityBirth"
                    [disabled]="isDisabled"
                    >{{ "chkObscuredAnonymityBirth" | translate }}</mat-checkbox
                >
                <mat-checkbox
                    *ngIf="customVisibility?.obscuredFamilyCounselingVisibility"
                    [(ngModel)]="obscuredData.obscuredFamilyCounseling"
                    [disabled]="isDisabled"
                    >{{ "chkObscuredFamilyCounseling" | translate }}</mat-checkbox
                >
            </div>
        </ng-container>

        <mat-form-field class="full-width mt-1">
            <mat-label>{{ "ObscuredAdditional" | translate }}</mat-label>
            <textarea
                matInput
                placeholder="{{ 'ObscuredAdditional' | translate }}"
                rows="8"
                [disabled]="isDisabled"
                [(ngModel)]="obscuredData.obscuredAdditional"
            ></textarea>
        </mat-form-field>

        <div class="full-width mt-1">
            <mat-label>{{ "ObscuredAvailability" | translate }}</mat-label>
            <se-smart-text-editor
                [suggestionList]="suggestions"
                [disabled]="isDisabled"
                [(ngModel)]="obscuredData.obscuredAvailability"
            >
            </se-smart-text-editor>
        </div>
    </mat-dialog-content>

    <ng-template #noData>
        <div class="se-dialog-content">No HardCodedData for Obscurity</div>
    </ng-template>

    <mat-dialog-actions align="end">
        <button mat-button color="primary" [mat-dialog-close]="obscuredData">
            {{ (showSaveButton ? "Save" : "Ok") | translate }}
        </button>
        <button mat-button mat-dialog-close>
            {{ "Cancel" | translate }}
        </button>
    </mat-dialog-actions>
</div>
